import { ReactNode, createContext, useContext } from 'react';

import { ProjectFragment } from '@spotify/confidence-graphql';

const ProjectContext = createContext<ProjectFragment | null>(null);

export const ProjectContextProvider = ({
  project,
  children,
}: {
  project: ProjectFragment | null;
  children: ReactNode;
}) => {
  return (
    <ProjectContext.Provider value={project}>
      {children}
    </ProjectContext.Provider>
  );
};

export const useProjectContext = (): ProjectFragment => {
  const project = useContext(ProjectContext);
  if (!project) {
    throw new Error(
      'useProjectContext must be used within a ProjectContextProvider with a non-null project',
    );
  }
  return project;
};

export const useOptionalProjectContext = (): ProjectFragment | null =>
  useContext(ProjectContext);
